import EmployeeAvatar from "../avatar/employee-avatar";
import '../../../styles/component/employee-overview/employee-overview.scss';
import CopyContent from "../../../common/copy-content";
import React from "react";
import {Mail, Phone, UserRound} from "lucide-react";
import {EmployeeDetailsOverviewProps} from "./types/employee-overview.types";
import {firstLetterUpperCase, removeUnderScoreWithLowerCase} from "../../../utility/utility";

const EmployeeOverview = (props: EmployeeDetailsOverviewProps) => {

    const getNameObject = (fullName: string) => {
        const parts = fullName.trim().split(" ");
        return {
            firstName: parts[0] || "",
            lastName: parts.slice(1).join(" ") || "",
        };
    };

    return (
        <>
            <div className={'employee-overview'}>
                <div className="employee-overview-header">
                    <div className="employee-overview-wrapper">
                        <div className="employee-overview avatar">
                            <EmployeeAvatar name={getNameObject(props.name)} size={20}
                                            thumbnailId={props.profilePhotoThumbnailId}/>
                        </div>
                        <div
                        className={`employee-overview-status-badge ${props.status}`}
                    >
                    </div>
                    </div>
                    <div className="employee-overview header-info">
                        <div className="employee-overview header-name">
                            {props.name}
                            {props.employmentType && (
                                <span className="employee-overview employment-badge">
                      {removeUnderScoreWithLowerCase(props.employmentType)}
                    </span>
                            )}
                        </div>
                        {
                            props.designation && <div className="employee-overview header-designation">
                                {props.designation}
                            </div>
                        }

                        <div className="employee-overview header-status-text">
                            {firstLetterUpperCase(props.status)}
                        </div>
                    </div>
                </div>

                <div className="employee-overview body">
                    {
                        props.officialEmail && <div className="employee-overview detail-row">
                            <Mail className={'employee-overview icon'}/>
                            {' '}
                            <div>
                                <div className="employee-overview detail-label">Email</div>
                                <div className="employee-overview detail-value">
                                    <CopyContent content={props?.officialEmail}>
                                        <a
                                            href={`https://mail.google.com/mail/?view=cm&fs=1&to=${props.officialEmail}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="email-link"
                                        >
                                            {props.officialEmail}
                                        </a>
                                    </CopyContent>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        props.mobileNumber?.number && <div className="employee-overview detail-row">
                            <Phone className={'employee-overview icon'}/>
                            {" "}
                            <div>
                                <div className="employee-overview detail-label">Phone</div>
                                <div className="employee-overview detail-value">
                                    <CopyContent
                                        content={props.mobileNumber.countryCode + '' + props.mobileNumber.number}>
                                        <a href={`tel:${props.mobileNumber.countryCode}${props.mobileNumber.number}`}
                                           className={'email-link'}>{props.mobileNumber.countryCode} {props.mobileNumber.number}</a>{' '}
                                    </CopyContent>
                                </div>
                            </div>
                        </div>
                    }

                    {props.reportingTo && <div className="employee-overview detail-row">
                        <UserRound className={'employee-overview icon'}/>
                        <div>
                            <div className="employee-overview detail-label">Reporting To</div>
                            <div className="employee-overview detail-value">
                                {props.reportingTo}
                            </div>
                        </div>
                    </div>
                    }

                </div>
            </div>
        </>
    )
}

export default EmployeeOverview;